import { createRoot } from 'react-dom/client'
import "./i18n";
import { Chart, registerables } from 'chart.js'
import { QueryClient, QueryClientProvider } from 'react-query'
import { MetronicI18nProvider } from './_metronic/i18n/Metronici18n'
import './_metronic/assets/sass/style.react.scss'
import './_metronic/assets/fonticon/fonticon.css'
import './_metronic/assets/keenicons/duotone/style.css'
import './_metronic/assets/keenicons/outline/style.css'
import './_metronic/assets/keenicons/solid/style.css'
import './_metronic/assets/sass/style.scss'

import './styles.scss'
import './variables.scss'
import { Bounce, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { RouteProvider } from './app/route-provider'
import { AuthProvider } from './app/modules/auth'

import '@/core/config/devextreme-license';
import { initializeSentry } from '@/core/sentry/sentry.config';

import { store } from './app/store'
import { Provider } from 'react-redux';

Chart.register(...registerables)
initializeSentry();

const queryClient = new QueryClient()
const container = document.getElementById('root')

if (container) {
  createRoot(container).render(
    <QueryClientProvider client={queryClient}>
      <MetronicI18nProvider>
        <AuthProvider>
          <Provider store={store}>
            <ToastContainer
              position="bottom-right"
              autoClose={5000}
              hideProgressBar
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="colored"
              transition={Bounce}
            />
            <RouteProvider />
          </Provider>
        </AuthProvider>
      </MetronicI18nProvider>
    </QueryClientProvider>
  )
}
